import React, { FC, memo } from 'react'
import { Button } from '@ucheba/ui/components/Button/desktop'
import Icon from '@ucheba/ui/icons/icon__pdf.svg'
import { analyticEvent } from '@ucheba/utils/helpers/analytics/events'
import {
  EAnalyticEvents,
  EAnalyticEventTargets,
  EAnalyticSections,
} from '@ucheba/utils/helpers/analytics/events/types'
import { IAdmissionInstructionButtonProps } from '../types'

const AdmissionInstructionButton: FC<IAdmissionInstructionButtonProps> = (props) => {
  const {
    institutionId,
    withIcon,
    textAlign = 'center',
    size,
    justifyContent,
    view = 'outline',
  } = props

  const tgLink = `/events/tg-subscribe/registration?templateId=10032&institution_id=${institutionId}&utm_medium=vuz_page&utm_source=ucheba&utm_campaign=leadmagnit`

  return (
    <Button
      block
      color='blue'
      view={view}
      href={tgLink}
      StartIcon={withIcon ? <Icon width='20px' color='blue' /> : withIcon}
      textAlign={textAlign}
      justifyContent={justifyContent}
      size={size}
      target='_blank'
      onClick={() => {
        analyticEvent({
          targets: [EAnalyticEventTargets.ym, EAnalyticEventTargets.ur],
          eventName: EAnalyticEvents.admissionGuideButtonClick,
          section: EAnalyticSections.admissionGuideButton,
        })
      }}
    >
      Гайд по поступлению
    </Button>
  )
}

export default memo(AdmissionInstructionButton)
